// import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
// import { register as registerSwiperElements } from "swiper/element/bundle";

// import { AppModule } from "./app/app.module";

// registerSwiperElements();

// platformBrowserDynamic()
//     .bootstrapModule(AppModule)
//     .catch((err) => console.error(err));

// NEW FORMAT

import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
